export enum AdminPermissions {
  NONE = 0,
  PRODUCTS = 1 << 1,
  ORDERS = 1 << 2,
  SHIPPING_PORTAL = 1 << 3,
  ATTENDEES = 1 << 4,
  REPORTING = 1 << 5,
  INVENTORY_COUNTS = 1 << 6,
  SETTINGS = 1 << 15,
}
